const route = {
	path: ':id/edit',
	name: 'customers-edit',
	meta: {
		title: 'Editar Compañía',
	},
	component: () => import('@/pages/customers/page-customer-new'),
	props: true,
};

export default route;



// WEBPACK FOOTER //
// ./src/router/customers-edit.js